import type {CodeListId} from 'domainTypes';
import type {PartCodeList, PartLinkedLiterary} from 'schemaDefinition/types';

export const getPartCodelistFromLinkedLiterary = (
  partLinkedLiterary: PartLinkedLiterary,
): PartCodeList | undefined => {
  return {
    type: 'codelist',
    name: 'role',
    codelistId: partLinkedLiterary.roleCodelistId as CodeListId,
    required: true,
  };
};
